import { render, staticRenderFns } from "./ProjectValuationScore.vue?vue&type=template&id=53ad87de&scoped=true&"
import script from "./ProjectValuationScore.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationScore.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationScore.vue?vue&type=style&index=0&id=53ad87de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad87de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
